import React, { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  List,
  ListItem,
  ListItemText,
  Checkbox,
  Typography,
  Box,
} from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

export const CardLayout1 = ({
  value,
  setValue,
  limit,
  register_page,
  page,
  setPage,
  open,
  setOpen,
  btn_label,
  default_btn_label,
  option_values,
  subtitle,
  popup_label,
  popup_content,
  sendMongoDBRegistration,
  required,
}) => {
  const toggleDialog1 = () => {
    setOpen(!open);
  };

  const [visible2, setVisible2] = useState(false);
  const toggleDialog2 = () => {
    setVisible2(!visible2);
  };

  const [checked, setChecked] = useState("");

  useEffect(() => {
    setChecked(value);
  }, [open]);

  useEffect(() => {
    if (checked !== value) {
      setValue(checked);
    }
  }, [checked]);

  return (
    <>
      {value.length === 0 && required && (
        <Typography color="error" variant="body2">
          This field is required.
        </Typography>
      )}
      {!register_page && (
        <List>
          <ListItem
            button
            onClick={toggleDialog1}
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "16px",
              border: `1px solid ${value.length === 0 && required ? "red" : "#ccc"}`,
              borderRadius: "8px",
              marginBottom: "8px",
            }}
          >
            <ListItemText primary={btn_label} />
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Typography variant="body2" sx={{ textAlign: "right", marginRight: "8px" }}>
                {default_btn_label}
              </Typography>
              <ChevronRightIcon />
            </Box>
          </ListItem>
        </List>
      )}
      <Dialog open={open} onClose={toggleDialog1}>
        <DialogTitle sx={{ textAlign: "center" }}>{btn_label}</DialogTitle>
        <DialogContent>
          <Typography variant="h6" sx={{ textAlign: "center" }}>
            {subtitle}
          </Typography>
          <Typography
            variant="body2"
            sx={{ textAlign: "center", cursor: "pointer", color: "blue", marginTop: "8px" }}
            onClick={toggleDialog2}
          >
            {popup_label}
          </Typography>
          <Box sx={{ maxHeight: "300px", overflowY: "auto", marginTop: "16px" }}>
            {option_values.map((item, i) => (
              <ListItem key={i} sx={{ display: "flex", justifyContent: "space-between" }}>
                <ListItemText primary={item} />
                <Checkbox
                  checked={checked.includes(i)}
                  onChange={() => {
                    if (checked.includes(i)) {
                      setChecked(checked.filter((item) => item !== i));
                    } else {
                      setChecked([...checked.filter((item) => item !== ""), i]);
                    }
                  }}
                />
              </ListItem>
            ))}
          </Box>
        </DialogContent>
        <DialogActions>
          <Box sx={{ width: "100%" }}>
            {limit !== 0 && limit + 1 <= checked.length && (
              <Typography color="error" variant="body2" sx={{ textAlign: "center" }}>
                Must choose only 1 value.
              </Typography>
            )}
            <Box sx={{ display: "flex", justifyContent: "space-between", marginTop: "16px" }}>
              {register_page ? (
                <Button
                  variant="contained"
                  disabled={limit !== 0 && limit + 1 <= checked.length}
                  onClick={() => {
                    setValue(checked);
                    setPage(page + 1);
                    sendMongoDBRegistration();
                  }}
                >
                  NEXT
                </Button>
              ) : (
                <Button
                  variant="contained"
                  onClick={() => {
                    sendMongoDBRegistration();
                    setOpen(false);
                  }}
                >
                  SAVE
                </Button>
              )}
            </Box>
            <Box sx={{ display: "flex", justifyContent: "space-between", marginTop: "8px" }}>
              {register_page ? (
                <Button
                  variant="text"
                  onClick={() => (page > 0 ? setPage(page - 1) : console.log("this is page 1"))}
                >
                  BACK
                </Button>
              ) : (
                <Button variant="text" onClick={() => setOpen(false)}>
                  CANCEL
                </Button>
              )}
            </Box>
          </Box>
        </DialogActions>
      </Dialog>
      <Dialog open={visible2} onClose={toggleDialog2}>
        <DialogTitle>{btn_label}</DialogTitle>
        <DialogContent>{popup_content}</DialogContent>
      </Dialog>
    </>
  );
};